var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHiddenIcon = function SvgHiddenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    color: "#949494",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M10.19 6.72a3.44 3.44 0 1 0 0 6.88 3.44 3.44 0 0 0 0-6.88Zm0 6.08c-1.46 0-2.64-1.18-2.64-2.64 0-1.46 1.18-2.64 2.64-2.64 1.46 0 2.64 1.18 2.64 2.64 0 1.46-1.18 2.64-2.64 2.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M10.25 5c-3.7 0-8.5 3.36-8.5 5.18 0 1.82 4.8 5.18 8.5 5.18s8.5-2.86 8.5-5.18S13.95 5 10.25 5Zm0 9.54c-3.14 0-7.5-3.04-7.58-4.38-.08-1.34 4.44-4.36 7.58-4.36 3.14 0 7.67 3.06 7.59 4.38-.08 1.32-4.45 4.36-7.59 4.36Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.73,
    height: 0.447,
    x: 2.055,
    y: 14.67,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.447,
    rx: 0.223,
    transform: "rotate(-30 2.055 14.67)"
  })));
};
export default SvgHiddenIcon;